import CareerGlobeArt from "./CareerGlobeArt";

/* rotating globe with the team's four points — Budapest, São Paulo,
   Singapore, Sydney — and the traffic between them */
export default function CareerNetworkArt() {
  return (
    <div className="career-art career-globe" aria-hidden="true">
      <CareerGlobeArt />
    </div>
  );
}
